import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {LoaderService} from '../../services/common/loader-service/loader.service';

@Injectable()
export class HttpLoaderInterceptorService implements HttpInterceptor {

    constructor(public loaderService: LoaderService) {
    }

    private urlsToIgnore = [
      'identity/userGroup/dryRun'
    ];
    private loginUrl = ['v1/login'];

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.showLoader(request);
        return next.handle(request)
            .pipe(
                finalize(() => {
                    this.stopLoader(request);
                })
            );
    }

    showLoader(request): void {
      // for login change the color of spinner
      if (request.url.includes(this.loginUrl) && request.method !== 'GET') {
        this.loaderService.show(true);
      } else if (!this.ignoreUrl(request.url) && request.method !== 'GET') {
            this.loaderService.show();
        }
    }

    stopLoader(request): void {
        if (!this.ignoreUrl(request.url) && request.method !== 'GET') {
            this.loaderService.hide();
        }
    }

    private ignoreUrl(requestUrl): boolean {
      return !!this.urlsToIgnore.find(url => {
        return requestUrl.includes(url);
      });
    }
}
